import { atom } from 'jotai';

export const sortByAtom = atom<string>('volume');
export const sortDescAtom = atom(false);

